// styles
import s from './Spinner.sss';

// types
type SpinnerProps = {
  size?: number;
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 4 }) => (
  <div className={s.wrapper}>
    <div
      className={s.root}
      style={{ fontSize: `${size}px` }}
    />
  </div>
);

export default Spinner;
